import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { AppProvider, useApp } from "@/context/AppContext";
import { t } from "@/lib/i18n";
import Header from "@/components/Header";
import AgeWarningModal from "@/components/AgeWarningModal";
import HomePage from "@/pages/HomePage";
import WordDetailPage from "@/pages/WordDetailPage";
import SubmitPage from "@/pages/SubmitPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminPanelPage from "@/pages/AdminPanelPage";
import Admin2FASetupPage from "@/pages/Admin2FASetupPage";
import { Toaster } from "@/components/ui/sonner";
import { useVersionCheck } from "@/lib/useVersionCheck";

function Shell() {
  const { ageAccepted, lang, setSourceLang } = useApp();
  const location = useLocation();
  useVersionCheck();

  // Source collection is driven by the URL: /es → Spanish, / and /no → Norwegian.
  useEffect(() => {
    setSourceLang(location.pathname.startsWith("/es") ? "es" : "no");
  }, [location.pathname, setSourceLang]);

  const canonical =
    typeof window !== "undefined"
      ? `${window.location.origin}${location.pathname}`
      : "";
  return (
    <>
      {canonical && (
        <Helmet>
          <link rel="canonical" href={canonical} />
        </Helmet>
      )}
      <AgeWarningModal />
      <div style={{ filter: ageAccepted ? "none" : "blur(8px)" }} aria-hidden={!ageAccepted}>
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/no" element={<HomePage />} />
          <Route path="/es" element={<HomePage />} />
          <Route path="/word/:id" element={<WordDetailPage />} />
          <Route path="/submit" element={<SubmitPage />} />
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin" element={<AdminPanelPage />} />
          <Route path="/admin/2fa" element={<Admin2FASetupPage />} />
        </Routes>
        <footer className="border-t border-gray-200 mt-24 py-10 flex flex-col items-center gap-5">
          <a
            data-testid="kofi-button"
            href="https://ko-fi.com/P2X0225IP4"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-full px-5 py-3 text-sm font-medium text-white shadow-sm transition-transform hover:scale-105"
            style={{ backgroundColor: "#72a4f2" }}
          >
            <img
              src="https://storage.ko-fi.com/cdn/cup-border.png"
              alt=""
              className="h-5 w-5"
              loading="lazy"
            />
            {t("kofi_support", lang)}
          </a>
          <p className="text-xs tracking-eyebrow text-gray-500">
            I Swear · 2026 · Made with frustration
          </p>
        </footer>
      </div>
      <Toaster position="top-center" />
    </>
  );
}

export default function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </AppProvider>
  );
}
